import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LogInModal from 'flarum/forum/components/LogInModal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import NagusiBackNav from '../common/NagusiBackNav';
export default class PlayerBirthdayPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "player", null);
    _defineProperty(this, "wishes", []);
    _defineProperty(this, "wishesCount", 0);
    _defineProperty(this, "availableYears", []);
    _defineProperty(this, "isSigningOpen", false);
    _defineProperty(this, "userWish", null);
    _defineProperty(this, "canWish", false);
    _defineProperty(this, "currentMessage", '');
    _defineProperty(this, "showEmojiPicker", false);
    _defineProperty(this, "error", null);
    _defineProperty(this, "successMessage", null);
    _defineProperty(this, "closeEmojiHandler", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle(app.translator.trans('bizkaitarra-lineup.forum.birthdays.page_title', {
      name: ''
    }));
    this.loadBirthdayData();
  }
  toggleEmojiPicker(e) {
    if (e) {
      e.stopPropagation();
    }
    this.showEmojiPicker = !this.showEmojiPicker;
    if (this.showEmojiPicker) {
      this.closeEmojiHandler = event => {
        const target = event.target;
        if (!target || !target.closest('.BirthdayWishBox-emoji-wrapper')) {
          this.showEmojiPicker = false;
          if (this.closeEmojiHandler) {
            document.removeEventListener('click', this.closeEmojiHandler, true);
            this.closeEmojiHandler = null;
          }
          m.redraw();
        }
      };
      setTimeout(() => {
        if (this.closeEmojiHandler) {
          document.addEventListener('click', this.closeEmojiHandler, true);
        }
      }, 0);
    } else {
      if (this.closeEmojiHandler) {
        document.removeEventListener('click', this.closeEmojiHandler, true);
        this.closeEmojiHandler = null;
      }
    }
    m.redraw();
  }
  onremove(vnode) {
    super.onremove(vnode);
    if (this.closeEmojiHandler) {
      document.removeEventListener('click', this.closeEmojiHandler, true);
      this.closeEmojiHandler = null;
    }
  }
  async loadBirthdayData() {
    this.loading = true;
    this.error = null;
    m.redraw();
    const slug = m.route.param('slug');
    try {
      const res = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/birthdays/").concat(slug)
      });
      this.player = res.player;
      this.wishes = res.wishes || [];
      this.wishesCount = res.wishesCount || 0;
      this.availableYears = res.availableYears || [];
      this.isSigningOpen = !!res.isSigningOpen;
      this.userWish = res.userWish || null;
      this.canWish = !!res.canWish;
      if (this.userWish) {
        this.currentMessage = this.userWish.message;
      }
      if (this.player) {
        app.setTitle(app.translator.trans('bizkaitarra-lineup.forum.birthdays.page_title', {
          name: this.player.name
        }));
      }
    } catch (e) {
      this.error = 'No se ha podido cargar la información de este cumpleaños.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  triggerConfetti() {
    const confettiCount = 60;
    const container = document.body;
    const baseUrl = app.forum.attribute('baseUrl').replace(/\/$/, '');
    const lionImgUrl = "".concat(baseUrl, "/api/custom-emojis/ee-leon-txapela");

    // 1. Confetis exclusivamente rojos y blancos (estilo Athletic Club)
    for (let i = 0; i < confettiCount; i++) {
      const el = document.createElement('div');
      el.className = 'birthday-confetti-particle';
      // Alternar o repartir al 50% entre rojo zurigorri y blanco puro
      const isRed = Math.random() > 0.48;
      el.style.backgroundColor = isRed ? '#EE2523' : '#FFFFFF';
      if (!isRed) {
        el.style.boxShadow = '0 0 4px rgba(0, 0, 0, 0.25)';
      }
      el.style.left = "".concat(Math.random() * 100, "vw");
      el.style.top = '-20px';
      el.style.width = "".concat(Math.random() * 8 + 7, "px");
      el.style.height = "".concat(Math.random() * 12 + 8, "px");
      el.style.opacity = "".concat(Math.random() * 0.4 + 0.6);
      el.style.transform = "rotate(".concat(Math.random() * 360, "deg)");
      el.style.animation = "birthdayConfettiFall ".concat(Math.random() * 2.2 + 2.3, "s linear forwards");
      container.appendChild(el);
      setTimeout(() => el.remove(), 4800);
    }

    // 2. Leones del Athletic cayendo festivos 🦁
    const lionCount = 14;
    for (let j = 0; j < lionCount; j++) {
      const lion = document.createElement('img');
      lion.className = 'birthday-confetti-lion';
      lion.src = lionImgUrl;
      lion.alt = 'León Athletic';
      lion.style.left = "".concat(Math.random() * 92 + 4, "vw");
      lion.style.top = '-50px';
      const size = Math.random() * 16 + 32; // entre 32px y 48px
      lion.style.width = "".concat(size, "px");
      lion.style.height = "".concat(size, "px");
      lion.style.animationDuration = "".concat(Math.random() * 2 + 2.8, "s");
      lion.style.animationDelay = "".concat(Math.random() * 0.7, "s");
      container.appendChild(lion);
      setTimeout(() => lion.remove(), 5500);
    }
  }
  insertEmoji(emojiName) {
    const tag = "[customemoji=".concat(emojiName, "]");
    this.currentMessage = this.currentMessage ? "".concat(this.currentMessage, " ").concat(tag, " ") : "".concat(tag, " ");
    this.showEmojiPicker = false;
    if (this.closeEmojiHandler) {
      document.removeEventListener('click', this.closeEmojiHandler, true);
      this.closeEmojiHandler = null;
    }
    m.redraw();
  }
  async submitWish(e) {
    e.preventDefault();
    const trimmed = (this.currentMessage || '').trim();
    if (!trimmed) {
      alert(app.translator.trans('bizkaitarra-lineup.forum.birthdays.empty_message_error'));
      return;
    }
    this.submitting = true;
    this.error = null;
    this.successMessage = null;
    m.redraw();
    const slug = m.route.param('slug');
    try {
      const res = await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/match-ratings/birthdays/").concat(slug, "/wishes"),
        body: {
          message: trimmed
        }
      });
      if (res.success && res.wish) {
        // Update local wishes
        const existingIdx = this.wishes.findIndex(w => w.userId === res.wish.userId);
        if (existingIdx !== -1) {
          this.wishes[existingIdx] = res.wish;
        } else {
          this.wishes.unshift(res.wish);
        }
        this.wishesCount = res.totalWishes;
        this.userWish = {
          id: res.wish.id,
          message: res.wish.message,
          createdAt: res.wish.createdAt
        };
        this.successMessage = app.translator.trans('bizkaitarra-lineup.forum.birthdays.wish_sent_success');
        this.triggerConfetti();
      }
    } catch (e) {
      var _e$response;
      this.error = (e == null || (_e$response = e.response) == null ? void 0 : _e$response.error) || 'Error al enviar la felicitación.';
    } finally {
      this.submitting = false;
      m.redraw();
    }
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "PlayerBirthdayPage"
      }, m("div", {
        className: "container",
        style: {
          padding: '60px 0',
          textAlign: 'center'
        }
      }, m(LoadingIndicator, null)));
    }
    if (this.error && !this.player) {
      return m("div", {
        className: "PlayerBirthdayPage"
      }, m("div", {
        className: "container",
        style: {
          padding: '40px 0',
          textAlign: 'center'
        }
      }, m("div", {
        className: "Alert Alert--error"
      }, this.error), m(Link, {
        href: "/",
        className: "Button Button--primary",
        style: {
          marginTop: '20px'
        }
      }, app.translator.trans('bizkaitarra-lineup.forum.birthdays.nav_back_home'))));
    }
    const player = this.player;
    const customEmojis = app.data.customEmojis || {};
    const emojiNames = Object.keys(customEmojis);
    return m("div", {
      className: "PlayerBirthdayPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      crumbs: [{
        url: app.route('bizkaitarra-lineup.players'),
        label: app.translator.trans('bizkaitarra-lineup.forum.birthdays.nav_players'),
        icon: 'fas fa-users'
      }, {
        url: "/jugador/".concat(player.slug),
        label: player.name,
        icon: 'fas fa-user'
      }],
      title: app.translator.trans('bizkaitarra-lineup.forum.birthdays.nav_guestbook', {
        year: player.year
      }),
      rightContent: m(Link, {
        href: "/jugador/".concat(player.slug),
        className: "NagusiBackNav-directBack"
      }, m("i", {
        className: "fas fa-arrow-left",
        style: {
          marginRight: '6px'
        }
      }), m("span", null, app.translator.trans('bizkaitarra-lineup.forum.birthdays.nav_back_player', {
        name: player.name
      })))
    }), m("div", {
      className: "BirthdayHero"
    }, m("div", {
      className: "BirthdayHero-confetti-bg"
    }), m("div", {
      className: "BirthdayHero-card"
    }, m("div", {
      className: "BirthdayHero-avatar-container"
    }, player.photoUrl ? m("img", {
      src: player.photoUrl,
      alt: player.name,
      className: "BirthdayHero-avatar"
    }) : m("div", {
      className: "BirthdayHero-avatar BirthdayHero-avatar--placeholder"
    }, m("i", {
      className: "fas fa-user"
    })), player.number && m("div", {
      className: "BirthdayHero-dorsal-tag"
    }, "#", player.number)), m("div", {
      className: "BirthdayHero-details"
    }, m("div", {
      className: "BirthdayHero-badges"
    }, player.age && m("span", {
      className: "BirthdayHero-pill BirthdayHero-pill--gold"
    }, "\uD83C\uDF82 ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.hero_age', {
      age: player.age
    })), !this.isSigningOpen && m("span", {
      className: "BirthdayHero-pill BirthdayHero-pill--closed"
    }, "\uD83D\uDD12 ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.guestbook_closed_badge')), player.ratingStats && m("span", {
      className: "BirthdayHero-pill BirthdayHero-pill--rating"
    }, "\u2B50 ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.season_rating', {
      rating: Number(player.ratingStats.average).toFixed(2),
      season: player.ratingStats.season
    }), ' ', m("small", {
      className: "BirthdayHero-pill-sub"
    }, app.translator.trans('bizkaitarra-lineup.forum.birthdays.season_rating_matches', {
      matches: player.ratingStats.matchesCount
    })))), m("h1", {
      className: "BirthdayHero-name"
    }, player.name), m("p", {
      className: "BirthdayHero-subtitle"
    }, app.translator.trans('bizkaitarra-lineup.forum.birthdays.page_subtitle', {
      name: player.name,
      age: player.age || ''
    })), m("div", {
      className: "BirthdayHero-stats"
    }, m("div", {
      className: "BirthdayHero-stat-item"
    }, m("span", {
      className: "BirthdayHero-stat-num"
    }, this.wishesCount), m("span", {
      className: "BirthdayHero-stat-lbl"
    }, app.translator.trans('bizkaitarra-lineup.forum.birthdays.wishes_count', {
      count: this.wishesCount
    }))))))), this.availableYears.length > 1 && m("div", {
      className: "BirthdayYearSelector"
    }, m("span", {
      className: "BirthdayYearSelector-label"
    }, m("i", {
      className: "fas fa-history"
    }), " ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.year_selector_label')), m("div", {
      className: "BirthdayYearSelector-pills"
    }, this.availableYears.map(item => {
      const isActive = item.year === player.year;
      return m(Link, {
        href: "/urtebetetzea/".concat(item.slug),
        className: "BirthdayYearSelector-pill ".concat(isActive ? 'is-active' : ''),
        key: item.year
      }, m("span", {
        className: "BirthdayYearSelector-year"
      }, item.year), m("span", {
        className: "BirthdayYearSelector-count"
      }, "(", app.translator.trans('bizkaitarra-lineup.forum.birthdays.year_selector_wishes', {
        count: item.wishesCount
      }), ")"));
    }))), !this.isSigningOpen ? m("div", {
      className: "BirthdayWishBox BirthdayWishBox--closed"
    }, m("div", {
      className: "BirthdayWishBox-closedContent"
    }, m("span", {
      className: "BirthdayWishBox-closedIcon"
    }, "\uD83D\uDCD6"), m("div", {
      className: "BirthdayWishBox-closedText"
    }, m("h4", null, app.translator.trans('bizkaitarra-lineup.forum.birthdays.guestbook_closed_badge')), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.birthdays.guestbook_closed_notice'))))) : m("div", {
      className: "BirthdayWishBox"
    }, m("h3", {
      className: "BirthdayWishBox-title"
    }, "\uD83E\uDD81 ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.form_title')), this.successMessage && m("div", {
      className: "Alert Alert--success",
      style: {
        marginBottom: '15px'
      }
    }, this.successMessage), this.userWish && !this.successMessage && m("div", {
      className: "BirthdayWishBox-notice"
    }, "\u2139\uFE0F ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.already_wished', {
      name: player.name
    })), this.canWish ? m("form", {
      onsubmit: e => this.submitWish(e)
    }, m("div", {
      className: "BirthdayWishBox-textarea-wrapper"
    }, m("textarea", {
      className: "FormControl BirthdayWishBox-textarea",
      rows: 3,
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.birthdays.form_placeholder'),
      value: this.currentMessage,
      oninput: e => {
        this.currentMessage = e.target.value;
      },
      disabled: this.submitting
    }), m("div", {
      className: "BirthdayWishBox-toolbar"
    }, emojiNames.length > 0 && m("div", {
      className: "BirthdayWishBox-emoji-wrapper"
    }, m("button", {
      type: "button",
      className: "Button Button--link BirthdayWishBox-emoji-btn",
      onclick: e => this.toggleEmojiPicker(e),
      title: app.translator.trans('bizkaitarra-lineup.forum.birthdays.stickers_tooltip')
    }, m("i", {
      className: "fas fa-smile"
    }), " ", m("span", null, app.translator.trans('bizkaitarra-lineup.forum.birthdays.stickers_btn'))), this.showEmojiPicker && m("div", {
      className: "BirthdayWishBox-emoji-dropdown",
      onclick: e => e.stopPropagation()
    }, m("div", {
      className: "BirthdayWishBox-emoji-grid"
    }, emojiNames.slice(0, 30).map(name => m("button", {
      type: "button",
      className: "BirthdayWishBox-emoji-item",
      onclick: () => this.insertEmoji(name),
      title: name
    }, m("img", {
      src: "".concat(app.forum.attribute('baseUrl').replace(/\/$/, ''), "/api/custom-emojis/").concat(name),
      alt: name
    })))))), m(Button, {
      type: "submit",
      className: "Button Button--primary BirthdayWishBox-submit-btn",
      loading: this.submitting,
      disabled: this.submitting || !this.currentMessage.trim()
    }, m("i", {
      className: "fas fa-paper-plane",
      style: {
        marginRight: '6px'
      }
    }), this.submitting ? app.translator.trans('bizkaitarra-lineup.forum.birthdays.sending_btn') : app.translator.trans('bizkaitarra-lineup.forum.birthdays.send_wish_btn'))))) : m("div", {
      className: "BirthdayWishBox-guest"
    }, m("p", null, app.translator.trans('bizkaitarra-lineup.forum.birthdays.guest_notice')), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, m("i", {
      className: "fas fa-sign-in-alt",
      style: {
        marginRight: '6px'
      }
    }), app.translator.trans('bizkaitarra-lineup.forum.birthdays.login_btn')))), m("div", {
      className: "BirthdayWishesWall"
    }, m("div", {
      className: "BirthdayWishesWall-header"
    }, m("h2", null, "\uD83D\uDCD6 ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.wall_title')), m("span", {
      className: "BirthdayWishesWall-badge"
    }, this.wishesCount)), this.wishes.length === 0 ? m("div", {
      className: "BirthdayWishesWall-empty"
    }, m("span", {
      className: "empty-icon"
    }, "\uD83E\uDD81"), m("p", null, app.translator.trans('bizkaitarra-lineup.forum.birthdays.no_wishes'))) : m("div", {
      className: "BirthdayWishesWall-grid"
    }, this.wishes.map(wish => m("div", {
      className: "BirthdayWishCard",
      key: wish.id
    }, m("div", {
      className: "BirthdayWishCard-author"
    }, m("div", {
      className: "BirthdayWishCard-avatar-wrapper"
    }, wish.avatarUrl ? m("img", {
      src: wish.avatarUrl,
      alt: wish.username,
      className: "BirthdayWishCard-avatar"
    }) : m("div", {
      className: "BirthdayWishCard-avatar BirthdayWishCard-avatar--placeholder"
    }, wish.username.charAt(0).toUpperCase())), m("div", {
      className: "BirthdayWishCard-meta"
    }, m(Link, {
      href: wish.userSlug ? "/u/".concat(wish.userSlug) : '#',
      className: "BirthdayWishCard-username"
    }, wish.username), m("span", {
      className: "BirthdayWishCard-time"
    }, wish.relativeTime))), m("div", {
      className: "BirthdayWishCard-body Post-body"
    }, m.trust(wish.renderedMessage))))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/PlayerBirthdayPage', PlayerBirthdayPage);